import { motion } from "framer-motion";

export default function About({ content }) {
  return (
    <section id="historia" className="relative py-24 md:py-36 bg-[#f9f6f0]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <motion.p
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="text-[#da251d] uppercase tracking-[0.3em] text-xs font-semibold mb-5"
            >
              Nuestra historia
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="font-display text-4xl md:text-6xl font-bold leading-[1.02] tracking-tight"
            >
              {content.about_heading}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="mt-7 text-[#57534e] text-lg leading-relaxed max-w-md"
            >
              {content.about_intro}
            </motion.p>
          </div>

          <div className="lg:col-span-7 lg:pt-10">
            <div className="divide-y divide-stone-200 border-t border-stone-200">
              {content.chapters?.map((c, i) => (
                <motion.div
                  key={c.id}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                  viewport={{ once: true, margin: "-60px" }}
                  className="py-8 grid grid-cols-[auto_1fr] gap-6 md:gap-10 group"
                >
                  <span className="font-display text-3xl md:text-5xl text-stone-300 group-hover:text-[#da251d] transition-colors duration-300">
                    {c.number}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl font-semibold mb-2">{c.title}</h3>
                    <p className="text-[#57534e] leading-relaxed">{c.text}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
